export const sum = (items, prop) => {
	if (items == null) {
		return 0;
	}
	return items.reduce(function (a, b) {
		return b[prop] == null ? a : a + b[prop];
	}, 0);
};

export const getPage = (data, page, pageSize) => {
	const start = (page - 1) * pageSize;
	const end = start + pageSize;
	return data.reduce((c, d, i) => {
		if (i >= start && i < end) {
			return c.concat([d]);
		}
		return c;
	}, []);
};

export const sort = (a, b, sortBy, asc) => {
	const value = x => (parseFloat(x) === NaN ? x : parseFloat(x));

	if (value(a[sortBy]) === value(b[sortBy])) {
		return a.name > b.name ? 1 : -1;
	} else {
		return value(a[sortBy]) > value(b[sortBy]) ? (asc ? -1 : 1) : asc ? 1 : -1;
	}
};

export const existsAndHasLength = arr => {
	return !!arr && typeof arr === 'object' && arr.length > 0;
};
